import { setSpecificMessage, mac } from "valibot";
setSpecificMessage(
  mac,
  (issue) => `MAC invalide: reçu ${issue.received}`,
  "fr"
);